import { Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { calculateAdvancement } from "../../utils/calculateAdvancement";

function handleRemoveAllocation(
  task: Identifiable<Task>,
  { uuid }: Boundaries["removeAllocation"]["request"],
): Identifiable<Task> {
  return calculateAdvancement({
    ...task,
    allocations: task.allocations.filter(
      (allocation) => allocation.uuid !== uuid,
    ),
  });
}

export { handleRemoveAllocation };
